import { render, staticRenderFns } from "./wtr-multiselect.vue?vue&type=template&id=7b8a6d37&scoped=true&"
import script from "./wtr-multiselect.vue?vue&type=script&lang=js&"
export * from "./wtr-multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a6d37",
  null
  
)

export default component.exports